@if (options.control) {
  <div
    class="radio__fancy flex justify-between items-center gap-4"
    [ngClass]="{ active: options.control.value === options.value }"
    (click)="updateValue()"
  >
    <div class="radio__icon" [inlineSVG]="options.icon"></div>

    <div class="radio__details flex flex-col flex-1">
      <h3 [translate]="options.label"></h3>
      <p [translate]="options.description"></p>
    </div>

    <div class="radio__input">
      <input
        type="radio"
        [id]="id"
        [formControl]="options.control"
        [value]="options.value"
      />
      <label [for]="id"></label>
    </div>
  </div>
}
